<template>
  <div>
    This will auto display all image assets in partners folder
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>